import React, { createContext, useCallback, useMemo, useState } from 'react';
import SystemData from '../../lib/systemData';

export const TitleContext = createContext({ title: '', setTitle: (value: string) => {} });

export default function TitleProvider({ children }: { children: React.ReactNode }) {
	const [title, setTitle] = useState('');

	const updateTitle = useCallback((newTitle) => {
		if (newTitle) {
			const { pageTitle } = SystemData.genericData.systemSettings;
			document.title = `${newTitle} - ${pageTitle}`;
			setTitle(newTitle);
		}
	}, [setTitle]);

	const value = useMemo(() => ({ title, setTitle: updateTitle }), [title, updateTitle]);

	return (
		<TitleContext.Provider value={value}>
			{ children }
		</TitleContext.Provider>
	);
}
